// extracted by mini-css-extract-plugin
export default {"wrapper":"MapLocation_wrapper__0fexQ","locationTitle":"MapLocation_locationTitle__Zceft","hovered":"MapLocation_hovered__yCizH"};